/*
 * Authors: mariushirjanu, Triadi, Koen
 * Created: 25/06/2019
 * Created: 09/01/2024
 */
import * as _ from 'underscore';
import { HttpDataService } from '../../http/http-data.service';

import { Injectable } from '@angular/core';
import { GaDeferredService, IGADeferred } from '../ga-deferred.service';

export interface ISearchResults {
  type:string;
  settings:{
    hideLinks:boolean;
  };
  data:ITypedSearchResult[];
}

interface ITypedSearchResult {
  id:number;
}

export interface IOrderSearchResult extends ITypedSearchResult {
  poNumber:string;
  customerReference:string;
  country:string;
  countryId?: number;
  status:string;
  etaDate:string;
  webshop?: string;
  webshopId?: number;
}

export interface IOrderSearchDetail extends IOrderSearchResult {
  trackingUrl: {
    url:string;
    trackingNumber:string;
  }[];
  bpReference:string;
  vendorReference:string;
  workflow:{
    date:string;
    comments:string;
    activeStep:boolean;
    stepState:string;
    steps:string[];
  }[];
}

@Injectable()
export class OrderSearchDataService {
  public static SEARCH_TYPE_ORDER:string = 'ORDER';

  constructor(
    private httpDataService:HttpDataService,
    private deferredService:GaDeferredService
  ) {
    /***/
  }

  // search orders using a notify callback containing the number of search results
  public search(filter:string, fast:boolean):Promise<ISearchResults[]> {
    return this.httpDataService.doGET('rest/quicksearch/search', {
      filter,
      fast
    }, undefined, 'Error searching');
  }

  public loadSearchDetail(type:string, id:string):Promise<IOrderSearchDetail> {
    return this.httpDataService.doGET(`rest/quicksearch/detail/${type}/${id}`, undefined, undefined, 'Error loading detail');
  }

  public myOpenOrders():Promise<ISearchResults[]> {
    return this.httpDataService.doGET('rest/quicksearch/myopen', undefined, undefined, 'Error loading open orders');
  }

  public combinedSearch(query:string, onNotify?:Function):Promise<ISearchResults[]> {
    const deferred:IGADeferred<ISearchResults[]> = this.deferredService.defer();

    const results:ISearchResults[] = [
      {
        type: OrderSearchDataService.SEARCH_TYPE_ORDER,
        data: [],
        settings: {
          hideLinks: false
        }
      }
    ];

    const addResults = (searchResults:ISearchResults[]) => {
      const orderResultSection:ISearchResults = _.findWhere(searchResults, { type: OrderSearchDataService.SEARCH_TYPE_ORDER });
      //remove search results that we already have
      const newSearchResults:IOrderSearchResult[] = _.filter(<IOrderSearchResult[]>orderResultSection.data, (orderSearchResult:IOrderSearchResult) => !_.findWhere(results[ 0 ].data, { id: orderSearchResult.id }));

      _.forEach(newSearchResults, (searchResult:IOrderSearchResult) => {
        (<any>searchResult).expanded = false;
      });

      //auto expand the first search result
      if (!results[ 0 ].data.length && newSearchResults.length === 1) {
        (<any>newSearchResults[ 0 ]).expanded = true;
      }

      results[ 0 ].data = results[ 0 ].data.concat(newSearchResults);
      results[ 0 ].settings.hideLinks = results[ 0 ].settings.hideLinks || (orderResultSection.settings && orderResultSection.settings.hideLinks);
    };


    // start both search queries at the same time
    Promise.all([
      this.search(query, true)
        .then(addResults)
        .finally(() => { // notify of intermediate results
          onNotify && onNotify(results);
        }),
      this.search(query, false)
        .then(addResults)
        .finally(() => { // notify of intermediate results
          onNotify && onNotify(results);
        })
    ]).then(() => {
      deferred.resolve(results);
    });

    return deferred.promise;
  }
}